/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCurrentUserInfo,
    InternalApiCurrentUserInfoFromJSON,
    InternalApiCurrentUserInfoToJSON,
} from '../models';

/**
 * 
 */
export class CurrentUserApi extends runtime.BaseAPI {

    /**
     * Fetches all info relevant to currently logged in user
     */
    async loadCurrentUserRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCurrentUserInfo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCurrentUserInfoFromJSON(jsonValue));
    }

    /**
     * Fetches all info relevant to currently logged in user
     */
    async loadCurrentUser(initOverrides?: RequestInit): Promise<InternalApiCurrentUserInfo> {
        const response = await this.loadCurrentUserRaw(initOverrides);
        return await response.value();
    }

}
